export const API = 'API'

export const INIT_APP = 'INIT_APP'
export const INIT_APP_SUCCESS = 'INIT_APP_SUCCESS'
export const INIT_APP_ERROR = 'INIT_APP_ERROR'

export const SEARCH_CUSTOMERS = 'SEARCH_CUSTOMERS'
export const SEARCH_CUSTOMERS_SUCCESS = 'SEARCH_CUSTOMERS_SUCCESS'
export const SEARCH_CUSTOMERS_ERROR = 'SEARCH_CUSTOMERS_ERROR'
export const SEARCH_CUSTOMERS_CLEAR = 'SEARCH_CUSTOMERS_CLEAR'

export const GET_CUSTOMER_SOLUTIONS = 'GET_CUSTOMER_SOLUTIONS'
export const GET_CUSTOMER_SOLUTIONS_SUCCESS = 'GET_CUSTOMER_SOLUTIONS_SUCCESS'
export const GET_CUSTOMER_SOLUTIONS_ERROR = 'GET_CUSTOMER_SOLUTIONS_ERROR'

export const SET_SOLUTIONS_CUSTOMER = 'SET_SOLUTIONS_CUSTOMER'
export const CLEAR_SELECTED_CUSTOMER = 'CLEAR_SELECTED_CUSTOMER'

export const STORE_CUSTOMER_SOLUTIONS = 'STORE_CUSTOMER_SOLUTIONS'
export const STORE_CUSTOMER_SOLUTIONS_SUCCESS =
    'STORE_CUSTOMER_SOLUTIONS_SUCCESS'
export const STORE_CUSTOMER_SOLUTIONS_ERROR = 'STORE_CUSTOMER_SOLUTIONS_ERROR'

export const SELECT_CMDB_CI_FILTER = 'SELECT_CMDB_CI_FILTER'
export const SELECT_CMDB_FILTER_VALUE = 'SELECT_CMDB_FILTER_VALUE'

export const GET_CUSTOMER_SOLUTIONS_RUNBOOK = 'GET_CUSTOMER_SOLUTIONS_RUNBOOK'
export const GET_CUSTOMER_SOLUTIONS_RUNBOOK_SUCCESS =
    'GET_CUSTOMER_SOLUTIONS_RUNBOOK_SUCCESS'
export const GET_CUSTOMER_SOLUTIONS_RUNBOOK_ERROR =
    'GET_CUSTOMER_SOLUTIONS_RUNBOOK_ERROR'

// export const SEARCH_DEVICES_ADVANCED = 'SEARCH_DEVICES_ADVANCED'
export const SEARCH_DEVICES_ADVANCED_SUCCESS = 'SEARCH_DEVICES_ADVANCED_SUCCESS'
export const SEARCH_DEVICES_ADVANCED_ERROR = 'SEARCH_DEVICES_ADVANCED_ERROR'

export const SEARCH_DEVICES = 'SEARCH_DEVICES'
export const SEARCH_DEVICES_SUCCESS = 'SEARCH_DEVICES_SUCCESS'
export const SEARCH_DEVICES_ERROR = 'SEARCH_DEVICES_ERROR'
export const SEARCH_DEVICES_CLEAR = 'SEARCH_DEVICES_CLEAR'

export const REFRESH_SOLUTION = 'REFRESH_SOLUTION'
export const REFRESH_SOLUTION_SUCCESS = 'REFRESH_SOLUTION_SUCCESS'
export const REFRESH_SOLUTION_ERROR = 'REFRESH_SOLUTION_ERROR'

export const PROCESS_ENQUEUED_REFRESH = 'PROCESS_ENQUEUED_REFRESH'

export const SEARCH_CMDB_CLASS = 'SEARCH_CMDB_CLASS'
export const SEARCH_CMDB_CLASS_SUCCESS = 'SEARCH_CMDB_CLASS_SUCCESS'
export const SEARCH_CMDB_CLASS_ERROR = 'SEARCH_CMDB_CLASS_ERROR'

export const SET_DEPTH_LEVEL = 'SET_DEPTH_LEVEL'
export const TOGGLE_RUNBOOKS_ACCESS_TYPE = 'TOGGLE_RUNBOOKS_ACCESS_TYPE'
export const TOGGLE_RUNBOOKS_ENVIRONMENT = 'TOGGLE_RUNBOOKS_ENVIRONMENT'
export const SET_CUSTOMER_FILTER = 'SET_CUSTOMER_FILTER'

export const CHANGE_RUNBOOKS_PAGE = 'CHANGE_RUNBOOKS_PAGE'

export const GET_RUNBOOKS = 'GET_RUNBOOKS'
export const GET_RUNBOOKS_SUCCESS = 'GET_RUNBOOKS_SUCCESS'
export const GET_RUNBOOKS_ERROR = 'GET_RUNBOOKS_ERROR'

export const GET_RUNBOOK_TEMPLATES = 'GET_RUNBOOK_TEMPLATES'
export const GET_RUNBOOK_TEMPLATES_SUCCESS = 'GET_RUNBOOK_TEMPLATES_SUCCESS'
export const GET_RUNBOOK_TEMPLATES_ERROR = 'GET_RUNBOOK_TEMPLATES_ERROR'
export const GET_RUNBOOK_TEMPLATE = 'GET_RUNBOOK_TEMPLATE'
export const GET_RUNBOOK_TEMPLATE_SUCCESS = 'GET_RUNBOOK_TEMPLATE_SUCCESS'
export const GET_RUNBOOK_TEMPLATE_ERROR = 'GET_RUNBOOK_TEMPLATE_ERROR'
export const GET_RUNBOOK_TEMPLATE_ACTIONS = 'GET_RUNBOOK_TEMPLATE_ACTIONS'
export const GET_RUNBOOK_TEMPLATE_ACTIONS_SUCCESS =
    'GET_RUNBOOK_TEMPLATE_ACTIONS_SUCCESS'
export const GET_RUNBOOK_TEMPLATE_ACTIONS_ERROR =
    'GET_RUNBOOK_TEMPLATE_ACTIONS_ERROR'
export const SAVE_RUNBOOK_TEMPLATE_ACTIONS = 'SAVE_RUNBOOK_TEMPLATE_ACTIONS'
export const SAVE_RUNBOOK_TEMPLATE_ACTIONS_SUCCESS =
    'SAVE_RUNBOOK_TEMPLATE_ACTIONS_SUCCESS'
export const SAVE_RUNBOOK_TEMPLATE_ACTIONS_ERROR =
    'SAVE_RUNBOOK_TEMPLATE_ACTIONS_ERROR'
export const CHANGE_RUNBOOK_TEMPLATES_PAGE = 'CHANGE_RUNBOOK_TEMPLATES_PAGE'
export const DELETE_RUNBOOK_TEMPLATE = 'DELETE_RUNBOOK_TEMPLATE'
export const DELETE_RUNBOOK_TEMPLATE_RECEIVED =
    'DELETE_RUNBOOK_TEMPLATE_RECEIVED'
export const DELETE_RUNBOOK_TEMPLATE_ERROR = 'DELETE_RUNBOOK_TEMPLATE_ERROR'
export const CREATE_RUNBOOK_TEMPLATE = 'CREATE_RUNBOOK_TEMPLATE'
export const CREATE_RUNBOOK_TEMPLATE_SUCCESS = 'CREATE_RUNBOOK_TEMPLATE_SUCCESS'
export const CREATE_RUNBOOK_TEMPLATE_ERROR = 'CREATE_RUNBOOK_TEMPLATE_ERROR'
export const UPDATE_RUNBOOK_TEMPLATE = 'UPDATE_RUNBOOK_TEMPLATE'
export const UPDATE_RUNBOOK_TEMPLATE_SUCCESS = 'UPDATE_RUNBOOK_TEMPLATE_SUCCESS'
export const UPDATE_RUNBOOK_TEMPLATE_ERROR = 'UPDATE_RUNBOOK_TEMPLATE_ERROR'
export const DELETE_TEMPLATE_ACTION = 'DELETE_TEMPLATE_ACTION'
export const DELETE_TEMPLATE_ACTION_RECEIVED = 'DELETE_TEMPLATE_ACTION_RECEIVED'
export const DELETE_TEMPLATE_ACTION_ERROR = 'DELETE_TEMPLATE_ACTION_ERROR'

export const GET_RUNBOOK = 'GET_RUNBOOK'
export const GET_RUNBOOK_RECEIVED = 'GET_RUNBOOK_RECEIVED'
export const GET_RUNBOOK_ERROR = 'GET_RUNBOOK_ERROR'
export const RESET_CREATE_RUNBOOK = 'RESET_CREATE_RUNBOOK'
export const RESET_CREATE_TEMPLATE = 'RESET_CREATE_TEMPLATE'

export const CREATE_RUNBOOK = 'CREATE_RUNBOOK'
export const CREATE_RUNBOOK_ERROR = 'CREATE_RUNBOOK_ERROR'

export const UPDATE_RUNBOOK = 'UPDATE_RUNBOOK'
export const APPLY_TEMPLATE_ACTIONS = 'APPLY_TEMPLATE_ACTIONS'
export const DELETE_MARKED_ACTIONS = 'DELETE_MARKED_ACTIONS'
export const UPDATE_RUNBOOK_SERVER = 'UPDATE_RUNBOOK_SERVER'
export const UPDATE_RUNBOOK_SERVER_RECEIVED = 'UPDATE_RUNBOOK_SERVER_RECEIVED'
export const UPDATE_RUNBOOK_SERVER_ERROR = 'UPDATE_RUNBOOK_SERVER_ERROR'

export const START_FORECASTING = 'START_FORECASTING'

export const EDIT_RUNBOOK_ACTIONS = 'EDIT_RUNBOOK_ACTIONS'
export const EDIT_RUNBOOK_ACTIONS_RECEIVED = 'EDIT_RUNBOOK_ACTIONS_RECEIVED'
export const EDIT_RUNBOOK_ACTIONS_ERROR = 'EDIT_RUNBOOK_ACTIONS_ERROR'

export const UPDATE_RUNBOOK_SESSION_ACTIONS = 'UPDATE_RUNBOOK_SESSION_ACTIONS'
export const UPDATE_RUNBOOK_SESSION_ACTIONS_RECEIVED =
    'UPDATE_RUNBOOK_SESSION_ACTIONS_RECEIVED'
export const UPDATE_RUNBOOK_SESSION_ACTIONS_ERROR =
    'UPDATE_RUNBOOK_SESSION_ACTIONS_ERROR'

export const COPY_RUNBOOK_SERVER = 'COPY_RUNBOOK_SERVER'
export const COPY_RUNBOOK_SERVER_RECEIVED = 'COPY_RUNBOOK_SERVER_RECEIVED'
export const COPY_RUNBOOK_SERVER_ERROR = 'COPY_RUNBOOK_SERVER_ERROR'

export const EXPORT_RUNBOOK = 'EXPORT_RUNBOOK'
export const EXPORT_RUNBOOK_LEGACY = 'EXPORT_RUNBOOK_LEGACY'
export const EXPORT_LIST_OF_RUNBOOKS_SUCCESS = 'EXPORT_LIST_OF_RUNBOOKS_SUCCESS'

export const EXPORT_HISTORY_LOGS = 'EXPORT_HISTORY_LOGS'
export const EXPORT_COMMENT_LOGS = 'EXPORT_COMMENT_LOGS'
export const EXPORT_ISSUE_LOGS = 'EXPORT_ISSUE_LOGS'
export const EXPORT_DECISION_LOGS = 'EXPORT_DECISION_LOGS'
export const EXPORT_ACTIVITIES_LOGS = 'EXPORT_ACTIVITIES_LOGS'

export const SET_ACTIVE_RUNBOOK = 'SET_ACTIVE_RUNBOOK'

export const DELETE_RUNBOOK = 'DELETE_RUNBOOK'
export const DELETE_RUNBOOK_RECEIVED = 'DELETE_RUNBOOK_RECEIVED'
export const DELETE_RUNBOOK_ERROR = 'DELETE_RUNBOOK_ERROR'

export const OPEN_SUPPLIER_MODAL = 'OPEN_SUPPLIER_MODAL'
export const CLOSE_SUPPLIER_MODAL = 'CLOSE_SUPPLIER_MODAL'

export const SAVE_SUPPLIER = 'SAVE_SUPPLIER'
export const SAVE_SUPPLIER_SUCCESS = 'SAVE_SUPPLIER_SUCESS'
export const SAVE_SUPPLIER_ERROR = 'SAVE_SUPPLIER_ERROR'

export const DELETE_SUPPLIER = 'DELETE_SUPPLIER'
export const DELETE_SUPPLIER_SUCCESS = 'DELETE_SUPPLIER_SUCCESS'
export const DELETE_SUPPLIER_ERROR = 'DELETE_SUPPLIER_ERROR'

export const GET_SUPPLIERS = 'GET_SUPPLIERS'
export const GET_SUPPLIERS_SUCCESS = 'GET_SUPPLIERS_SUCCESS'
export const GET_SUPPLIERS_ERROR = 'GET_SUPPLIERS_ERROR'

export const GET_CMDB_CONTACTS = 'GET_CMDB_CONTACTS'
export const GET_CMDB_CONTACTS_SUCCESS = 'GET_CMDB_CONTACTS_SUCCESS'
export const GET_CMDB_CONTACTS_ERROR = 'GET_CMDB_CONTACTS_ERROR'

export const SAVE_CMDB_CONTACT = 'SAVE_CMDB_CONTACT'
export const SAVE_CMDB_CONTACT_SUCCESS = 'SAVE_CMDB_CONTACT_SUCCESS'
export const SAVE_CMDB_CONTACT_ERROR = 'SAVE_CMDB_CONTACT_ERROR'

export const GET_CMDB_TEAMS = 'GET_CMDB_TEAMS'
export const GET_CMDB_TEAMS_SUCCESS = 'GET_CMDB_TEAMS_SUCCESS'
export const GET_CMDB_TEAMS_ERROR = 'GET_CMDB_TEAMS_ERROR'

export const SAVE_CMDB_TEAM = 'SAVE_CMDB_TEAM'
export const SAVE_CMDB_TEAM_SUCCESS = 'SAVE_CMDB_TEAM_SUCCESS'
export const SAVE_CMDB_TEAM_ERROR = 'SAVE_CMDB_TEAM_ERROR'

export const TOGGLE_DEVICE_IMPORT = 'TOGGLE_DEVICE_IMPORT'
export const TOGGLE_ALL_DEVICES_IMPORT = 'TOGGLE_ALL_DEVICES_IMPORT'
export const TOGGLE_CONTACT_IMPORT = 'TOGGLE_CONTACT_IMPORT'
export const TOGGLE_ALL_CONTACTS_IMPORT = 'TOGGLE_ALL_CONTACTS_IMPORT'
export const TOGGLE_TEAM_IMPORT = 'TOGGLE_TEAM_IMPORT'
export const TOGGLE_ALL_TEAMS_IMPORT = 'TOGGLE_ALL_TEAMS_IMPORT'

export const SET_CMDB_IMPORT_CONTACT_TYPE = 'SET_CMDB_IMPORT_CONTACT_TYPE'

export const GET_OWNER_RESULTS = 'GET_OWNER_RESULTS'
export const GET_OWNER_RESULTS_SUCCESS = 'GET_OWNER_RESULTS_SUCCESS'
export const GET_OWNER_RESULTS_ERROR = 'GET_OWNER_RESULTS_ERROR'

export const GET_ACTION_LOGS = 'GET_ACTION_LOGS'
export const GET_ACTION_LOGS_SUCCESS = 'GET_ACTION_LOGS_SUCCESS'
export const GET_ACTION_LOGS_ERROR = 'GET_ACTION_LOGS_ERROR'

export const GET_ALL_ACTION_LOGS = 'GET_ALL_ACTION_LOGS'
export const GET_ALL_ACTION_LOGS_SUCCESS = 'GET_ALL_ACTION_LOGS_SUCCESS'
export const GET_ALL_ACTION_LOGS_ERROR = 'GET_ALL_ACTION_LOGS_ERROR'

export const GET_ALL_DECISION_LOGS = 'GET_ALL_DECISION_LOGS'
export const GET_ALL_DECISION_LOGS_SUCCESS = 'GET_ALL_DECISION_LOGS_SUCCESS'
export const GET_ALL_DECISION_LOGS_ERROR = 'GET_ALL_DECISION_LOGS_ERROR'

export const GET_ALL_ISSUE_LOGS = 'GET_ALL_ISSUE_LOGS'
export const GET_ALL_ISSUE_LOGS_SUCCESS = 'GET_ALL_ISSUE_LOGS_SUCCESS'
export const GET_ALL_ISSUE_LOGS_ERROR = 'GET_ALL_ISSUE_LOGS_ERROR'

export const GET_ALL_ACTIVITY_LOGS = 'GET_ALL_ACTIVITY_LOGS'
export const GET_ALL_ACTIVITY_LOGS_SUCCESS = 'GET_ALL_ACTIVITY_LOGS_SUCCESS'
export const GET_ALL_ACTIVITY_LOGS_ERROR = 'GET_ALL_ACTIVITY_LOGS_ERROR'

export const RUNBOOK_ACTIONS_LOADING = 'RUNBOOK_ACTIONS_LOADING'
export const FILTER_RUNBOOK_ACTIONS = 'FILTER_RUNBOOK_ACTIONS'
export const ADD_NEW_ACTION = 'ADD_NEW_ACTION'
export const ADD_NEW_DEVICE = 'ADD_NEW_DEVICE'
export const ADD_NEW_DECISION = 'ADD_NEW_DECISION'
export const ADD_NEW_ISSUE = 'ADD_NEW_ISSUE'
export const ADD_SOLUTION_WITH_CHILDREN = 'ADD_SOLUTION_WITH_CHILDREN'
export const EXPAND_ACTION = 'EXPAND_ACTION'
export const UPDATE_ACTION = 'UPDATE_ACTION'
export const MOVE_ACTION = 'MOVE_ACTION'
export const MOVE_ACTIONS = 'MOVE_ACTIONS'
export const DELETE_ACTION_START = 'DELETE_ACTION_START'
export const DELETE_ACTION = 'DELETE_ACTION'
export const DELETE_ACTION_END = 'DELETE_ACTION_END'
export const FOCUS_ACTION = 'FOCUS_ACTION'
export const MARK_INFO_ONLY = 'MARK_INFO_ONLY'
export const UNMARK_FOR_DELETION = 'UNMARK_FOR_DELETION'
export const TOGGLE_FREEZE_OWNER = 'TOGGLE_FREEZE_OWNER'

export const ADD_NEW_COMMENT = 'ADD_NEW_COMMENT'
export const ADD_NEW_COMMENT_SUCCESS = 'ADD_NEW_COMMENT_SUCCESS'
export const ADD_NEW_COMMENT_ERROR = 'ADD_NEW_COMMENT_ERROR'

export const OPEN_NEW_DOCUMENTATION_MODAL = 'OPEN_NEW_DOCUMENTATION_MODAL'
export const CLOSE_NEW_DOCUMENTATION_MODAL = 'CLOSE_NEW_DOCUMENTATION_MODAL'
export const OPEN_EDIT_DOCUMENTATION_MODAL = 'OPEN_EDIT_DOCUMENTATION_MODAL'
export const CLOSE_EDIT_DOCUMENTATION_MODAL = 'CLOSE_EDIT_DOCUMENTATION_MODAL'

export const SAVE_DOCUMENTATION = 'SAVE_DOCUMENTATION'
export const SAVE_DOCUMENTATION_SUCCESS = 'SAVE_DOCUMENTATION_SUCCESS'
export const SAVE_DOCUMENTATION_ERROR = 'SAVE_DOCUMENTATION_ERROR'
export const DELETE_DOCUMENTATION = 'DELETE_DOCUMENTATION'
export const DELETE_DOCUMENTATION_SUCCESS = 'DELETE_DOCUMENTATION_SUCCESS'
export const DELETE_DOCUMENTATION_ERROR = 'DELETE_DOCUMENTATION_ERROR'
export const GET_DOCUMENTATIONS = 'GET_DOCUMENTATIONS'
export const GET_DOCUMENTATIONS_SUCCESS = 'GET_DOCUMENTATIONS_SUCCESS'
export const GET_DOCUMENTATIONS_ERROR = 'GET_DOCUMENTATIONS_ERROR'

export const GET_CUSTOMER_ZONES = 'GET_CUSTOMER_ZONES'
export const GET_CUSTOMER_ZONES_SUCCESS = 'GET_CUSTOMER_ZONES_SUCCESS'
export const GET_CUSTOMER_ZONES_ERROR = 'GET_CUSTOMER_ZONES_ERROR'

export const START_RUNBOOK_SESSION = 'START_RUNBOOK_SESSION'
export const START_RUNBOOK_SESSION_SUCCESS = 'START_RUNBOOK_SESSION_SUCCESS'
export const START_RUNBOOK_SESSION_FAILED = 'START_RUNBOOK_SESSION_FAILED'

export const END_RUNBOOK_SESSION = 'END_RUNBOOK_SESSION'
export const END_RUNBOOK_SESSION_SUCCESS = 'END_RUNBOOK_SESSION_SUCCESS'
export const END_RUNBOOK_SESSION_FAILED = 'END_RUNBOOK_SESSION_FAILED'

export const SELECT_RUNBOOK_WINDOW = 'SELECT_RUNBOOK_WINDOW'

export const GENERATE_RUNBOOK_CSV = 'GENERATE_RUNBOOK_CSV'
export const GENERATE_RUNBOOK_CSV_SUCCESS = 'GENERATE_RUNBOOK_CSV_SUCCESS'
export const GENERATE_RUNBOOK_CSV_ERROR = 'GENERATE_RUNBOOK_CSV_ERROR'

export const TOAST_SHOW = 'TOAST_SHOW'
export const TOAST_REMOVE = 'TOAST_REMOVE'

export const SET_RUNBOOK_FORECAST = 'SET_RUNBOOK_FORECAST'
export const SET_SELECTED_ACTION_ID = 'SET_SELECTED_ACTION_ID'
